module.exports = __webpack_public_path__ + "img/romel.039484b4.png";